import AGLogo from './AGLogo.client'
export default AGLogo
